import React, { useEffect, useState, createElement } from 'react';
import { HeroSection } from '../components/stingfit-v2/HeroSection';
import { MiniBundles } from '../components/stingfit-v2/MiniBundles';
import { SocialProofSeal } from '../components/stingfit-v2/SocialProofSeal';
import { ProblemEscalation } from '../components/stingfit-v2/ProblemEscalation';
import { MechanismSection } from '../components/stingfit-v2/MechanismSection';
import { DoctorEndorsementSection } from '../components/stingfit-v2/DoctorEndorsementSection';
import { BenefitsTimeline } from '../components/stingfit-v2/BenefitsTimeline';
import { HowItWorks } from '../components/stingfit-v2/HowItWorks';
import { ProductShowcase } from '../components/stingfit-v2/ProductShowcase';
import { EbookSection } from '../components/stingfit-v2/EbookSection';
import { ProblemReframe } from '../components/stingfit-v2/ProblemReframe';
import { TestimonialGrid } from '../components/stingfit-v2/TestimonialGrid';
import { BeforeAfterSection } from '../components/stingfit-v2/BeforeAfterSection';
import { ResultsCollageSection } from '../components/stingfit-v2/ResultsCollageSection';
import { OfferStack } from '../components/stingfit-v2/OfferStack';
import { PricingBundles } from '../components/stingfit-v2/PricingBundles';
import { FAQAccordion } from '../components/stingfit-v2/FAQAccordion';
import { Button } from '../components/stingfit-v2/ui/Button';
import { ShieldCheck, Truck, CreditCard, Zap } from 'lucide-react';
import { ScienceCallout, WhyItWorks, RoutineStrip, ComparisonTable, ForWhomBanner, PullQuote, IngredientsSpotlight, SocialTicker } from '../components/stingfit-v2/BrandStrips';
export function StingFitLandingV2() {
  const [activeModal, setActiveModal] = useState<'terminos' | 'privacidad' | 'contacto' | null>(null);
  const [stock, setStock] = useState(23);
  useEffect(() => {
    // Meta Pixel
    const pixelId = '965958182359799';
    if (!(window as any).fbq) {
      const fbq: any = function () {
        fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
      };
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = '2.0';
      fbq.queue = [];
      (window as any).fbq = fbq;
      (window as any)._fbq = fbq;
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    ;
    (window as any).fbq('init', pixelId);
    (window as any).fbq('track', 'PageView');
    const interval = setInterval(() => {
      setStock(s => {
        if (s <= 7) return s;
        return Math.random() > 0.7 ? s - 1 : s;
      });
    }, 45000);
    return () => clearInterval(interval);
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-1397">
      {/* Modals */}
      {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-id="element-1398">
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-1399" />
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-y-auto p-8 z-10" data-id="element-1400">
            <button onClick={() => setActiveModal(null)} className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl font-bold leading-none" data-id="element-1401">
              ×
            </button>

            {activeModal === 'terminos' && <>
                <h2 className="text-2xl font-black text-[#2D5016] mb-4" data-id="element-1402">
                  Términos y Condiciones
                </h2>
                <div className="text-sm text-gray-600 space-y-3 leading-relaxed" data-id="element-1403">
                  <p data-id="element-1404">
                    Al realizar una compra en StingFit México, aceptas los
                    siguientes términos y condiciones.
                  </p>
                  <p data-id="element-1405">
                    <strong data-id="element-1406">Productos:</strong> Todos los productos son
                    suplementos alimenticios. Los resultados pueden variar según
                    cada persona.
                  </p>
                  <p data-id="element-1407">
                    <strong data-id="element-1408">Pagos:</strong> Los pagos se procesan de forma
                    segura. Aceptamos las principales tarjetas de crédito,
                    débito, OXXO y pago contra entrega.
                  </p>
                  <p data-id="element-1409">
                    <strong data-id="element-1410">Envíos:</strong> Los pedidos se procesan en 1-2 días
                    hábiles. El tiempo de entrega estimado es de 3-10 días
                    hábiles en la República Mexicana.
                  </p>
                  <p data-id="element-1411">
                    <strong data-id="element-1412">Garantía:</strong> Ofrecemos una garantía de
                    devolución de 90 días. Si no estás satisfecho, te devolvemos
                    el dinero sin preguntas.
                  </p>
                  <p data-id="element-1413">
                    <strong data-id="element-1414">Uso:</strong> Los productos deben usarse según las
                    instrucciones del fabricante. No reemplaza el consejo médico
                    profesional.
                  </p>
                </div>
              </>}

            {activeModal === 'privacidad' && <>
                <h2 className="text-2xl font-black text-[#2D5016] mb-4" data-id="element-1415">
                  Política de Privacidad
                </h2>
                <div className="text-sm text-gray-600 space-y-3 leading-relaxed" data-id="element-1416">
                  <p data-id="element-1417">
                    En StingFit México nos comprometemos a proteger tu
                    privacidad y tus datos personales.
                  </p>
                  <p data-id="element-1418">
                    <strong data-id="element-1419">Datos que recopilamos:</strong> Nombre, dirección de
                    correo electrónico, dirección de envío y datos de pago
                    necesarios para procesar tu pedido.
                  </p>
                  <p data-id="element-1420">
                    <strong data-id="element-1421">Uso de datos:</strong> Utilizamos tus datos
                    únicamente para procesar pedidos, enviarte información sobre
                    tu compra y mejorar nuestros servicios.
                  </p>
                  <p data-id="element-1422">
                    <strong data-id="element-1423">Compartición de datos:</strong> No vendemos ni
                    compartimos tus datos personales con terceros, salvo con
                    proveedores de servicios necesarios para completar tu
                    pedido.
                  </p>
                  <p data-id="element-1424">
                    <strong data-id="element-1425">Cookies:</strong> Utilizamos cookies para mejorar tu
                    experiencia de navegación. Puedes desactivarlas en la
                    configuración de tu navegador.
                  </p>
                  <p data-id="element-1426">
                    <strong data-id="element-1427">Tus derechos:</strong> Tienes derecho a acceder,
                    rectificar o eliminar tus datos personales. Contáctanos para
                    ejercer estos derechos.
                  </p>
                  <p data-id="element-1428">
                    <strong data-id="element-1429">Ley de Protección de Datos:</strong> Cumplimos con
                    la Ley Federal de Protección de Datos Personales en Posesión
                    de los Particulares (LFPDPPP) de México.
                  </p>
                </div>
              </>}

            {activeModal === 'contacto' && <>
                <h2 className="text-2xl font-black text-[#2D5016] mb-4" data-id="element-1430">
                  Contacto
                </h2>
                <div className="text-sm text-gray-600 space-y-4 leading-relaxed" data-id="element-1431">
                  <p data-id="element-1432">¿Tienes alguna pregunta? Estamos aquí para ayudarte.</p>
                  <div className="bg-[#D4AF37]/10 rounded-xl p-4 space-y-2" data-id="element-1433">
                    <p data-id="element-1434">
                      <strong className="text-[#2D5016]" data-id="element-1435">📧 Email:</strong>{' '}
                      contact@glowliftessencemx.com
                    </p>
                    <p data-id="element-1436">
                      <strong className="text-[#2D5016]" data-id="element-1437">🕐 Horario:</strong>{' '}
                      Lunes a Viernes, 9:00 – 18:00 (CST)
                    </p>
                    <p data-id="element-1438">
                      <strong className="text-[#2D5016]" data-id="element-1439">📦 Pedidos:</strong>{' '}
                      Respuesta en menos de 24 horas hábiles
                    </p>
                  </div>
                  <p data-id="element-1440">
                    Para devoluciones o cambios, incluye tu número de pedido en
                    el asunto del correo. Procesamos todas las solicitudes de
                    garantía en un plazo de 2-3 días hábiles.
                  </p>
                </div>
              </>}

            <button onClick={() => setActiveModal(null)} className="mt-6 w-full bg-[#2D5016] text-white font-bold py-3 rounded-xl hover:bg-[#3a6a1e] transition-colors" data-id="element-1441">
              Cerrar
            </button>
          </div>
        </div>}

      {/* TOP URGENCY BAR */}
      <div className="bg-gradient-to-r from-red-700 via-red-600 to-red-700 text-white py-2.5 px-4 text-center text-sm font-bold relative overflow-hidden" data-id="element-1442">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMjAiIGN5PSIyMCIgcj0iMSIgZmlsbD0id2hpdGUiIG9wYWNpdHk9IjAuMSIvPjwvc3ZnPg==')] opacity-30" data-id="element-1443"></div>
        <span className="relative flex items-center justify-center gap-2 flex-wrap" data-id="element-1444">
          <span className="animate-pulse" data-id="element-1445">⚡</span>
          <span data-id="element-1446">OFERTA FLASH: Envío GRATIS + Descuento Especial Activo</span>
          <span className="bg-white/20 px-2 py-0.5 rounded-full text-xs" data-id="element-1447">
            Solo quedan{' '}
            <span className="font-black text-yellow-300" data-id="element-1448">{stock} unidades</span>
          </span>
          <span className="animate-pulse" data-id="element-1449">⚡</span>
        </span>
      </div>

      <SocialTicker data-id="element-1450" />

      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm py-3" data-id="element-1451">
        <div className="container mx-auto px-4 flex justify-between items-center max-w-6xl" data-id="element-1452">
          <div className="text-2xl font-black text-[#2D5016] tracking-tighter" data-id="element-1453">
            STING<span className="text-[#D4AF37]" data-id="element-1454">FIT</span>
          </div>
          <div className="flex items-center gap-3" data-id="element-1455">
            <div className="hidden sm:flex items-center gap-1.5 text-xs text-green-700 font-semibold bg-green-50 px-3 py-1.5 rounded-full border border-green-200" data-id="element-1456">
              <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-1457"></span>
              {stock} unidades restantes
            </div>
            <Button size="sm" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-1458">
              🛒 Comprar Ahora
            </Button>
          </div>
        </div>
      </header>

      <main data-id="element-1459">
        <HeroSection data-id="element-1460" />
        <MiniBundles data-id="element-1461" />
        <SocialProofSeal data-id="element-1462" />
        <ForWhomBanner data-id="element-1463" />
        <ProblemEscalation data-id="element-1464" />
        <ScienceCallout data-id="element-1465" />
        <IngredientsSpotlight data-id="element-1466" />
        <MechanismSection data-id="element-1467" />
        <DoctorEndorsementSection data-id="element-1468" />
        <WhyItWorks data-id="element-1469" />
        <BenefitsTimeline data-id="element-1470" />
        <RoutineStrip data-id="element-1471" />
        <HowItWorks data-id="element-1472" />
        <ProductShowcase data-id="element-1473" />
        <EbookSection data-id="element-1474" />
        <ProblemReframe data-id="element-1475" />
        <PullQuote data-id="element-1476" />
        <ComparisonTable data-id="element-1477" />
        <TestimonialGrid data-id="element-1478" />
        <BeforeAfterSection data-id="element-1479" />
        <ResultsCollageSection data-id="element-1480" />
        <OfferStack data-id="element-1481" />
        <PricingBundles data-id="element-1482" />
        <FAQAccordion data-id="element-1483" />
      </main>

      {/* Sticky Mobile Bottom CTA */}
      <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden bg-white border-t-2 border-[#D4AF37] shadow-2xl px-4 py-3" data-id="element-1484">
        <div className="flex items-center gap-3" data-id="element-1485">
          <div className="flex-1 min-w-0" data-id="element-1486">
            <p className="text-xs text-gray-500 leading-tight" data-id="element-1487">Pack 3 Meses</p>
            <div className="flex items-baseline gap-1.5" data-id="element-1488">
              <span className="text-lg font-black text-[#2D5016]" data-id="element-1489">
                $1,199 MXN
              </span>
              <span className="text-xs text-gray-400 line-through" data-id="element-1490">
                $3,600 MXN
              </span>
              <span className="text-xs font-bold text-green-600 bg-green-50 px-1.5 py-0.5 rounded" data-id="element-1491">
                -67%
              </span>
            </div>
          </div>
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="flex-shrink-0 bg-[#D4AF37] text-white font-black text-sm px-5 py-3 rounded-full shadow-lg active:scale-95 transition-transform uppercase tracking-wide animate-pulse" data-id="element-1492">
            ¡QUIERO ESTO! →
          </button>
        </div>
      </div>

      <footer className="bg-[#2D5016] text-white py-12 border-t border-white/10 pb-24 md:pb-12" data-id="element-1493">
        <div className="container mx-auto px-4 text-center max-w-6xl" data-id="element-1494">
          <div className="text-2xl font-black tracking-tighter mb-4" data-id="element-1495">
            STING<span className="text-[#D4AF37]" data-id="element-1496">FIT</span>
          </div>
          {/* Payment icons */}
          <div className="flex justify-center items-center gap-3 mb-6 flex-wrap" data-id="element-1497">
            {['VISA', 'MC', 'AMEX', 'PAYPAL', 'OXXO', 'CONTRA ENTREGA'].map(p => <span key={p} className="bg-white/10 text-white/70 text-xs font-bold px-3 py-1 rounded border border-white/20" data-id="element-1498">
                  {p}
                </span>)}
            <span className="bg-white/10 text-white/70 text-xs font-bold px-3 py-1 rounded border border-white/20 flex items-center gap-1" data-id="element-1499">
              🔒 256-bit SSL
            </span>
          </div>
          <div className="flex justify-center gap-6 mb-8 text-sm text-green-100" data-id="element-1500">
            <button onClick={() => setActiveModal('terminos')} className="hover:text-white transition-colors cursor-pointer" data-id="element-1501">
              Términos
            </button>
            <button onClick={() => setActiveModal('privacidad')} className="hover:text-white transition-colors cursor-pointer" data-id="element-1502">
              Privacidad
            </button>
            <button onClick={() => setActiveModal('contacto')} className="hover:text-white transition-colors cursor-pointer" data-id="element-1503">
              Contacto
            </button>
          </div>
          <p className="text-xs text-green-200/50 max-w-2xl mx-auto" data-id="element-1504">
            © 2026 StingFit México. Todos los derechos reservados. Este sitio
            no es parte del sitio web de Facebook o Facebook Inc. Además, este
            sitio no está respaldado por Facebook de ninguna manera. FACEBOOK es
            una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}